<template>
    <div class="logos-app-root">
        <div class="controls" v-if="showControls">
            <div>
                <label for="logos-app-controls-name">Logo Name</label>
                <input id="logos-app-controls-name" name="name" v-model="new_logo.name">
            </div>
            <div>
                <label for="logos-app-controls-file">Upload a new image</label>
                <input id="logos-app-controls-file" ref="filepicker" type="file" name="file" @change="previewFileUpload">
            </div>
            <div class="external">
                <label for="logos-app-controls-url">or Add an image from the internet</label>
                <div class="input">
                    <input id="logos-app-controls-url" name="external_url" v-model="new_logo.url" placeholder="Image URL">
                    <button v-on:click="fetchExternal">Preview</button>
                </div>
            </div>
            <img v-if="new_logo.imagePreview" :src="new_logo.imagePreview" class="preview">
            <button class="save" v-on:click="saveNewLogo" v-if="!saving">Save new logo</button>
            <img v-if="saving" class="saving" src="/icons/saving.gif">
        </div>
        <div class="list">
            <div class="list-filter">
                <label for="logos-app-list-filter">Filter list</label>
                <input id="logos-app-list-filter" name="list-filter" v-model="filter">
            </div>
            <div class="logos-list">
                <input ref="logoCopy" class="hide-offscreen">
                <div class="logo" v-for="logo in logos" v-if="logo.name.toLowerCase().includes(filter.toLowerCase())">
                    <div>
                        <div class="img"><a :href="logo.image"><img :src="logo.image"></a></div>
                        <div>
                            <h3>{{logo.name}}</h3>
                            <a :href="logo.image">{{logo.image}}</a>
                        </div>
                    </div>
                    <button v-on:click="copy(logo.image, $event)" :class="copyLogoImage === logo.image ? 'secondary' : ''">Copy</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'logos-app',
        data(){
            return {
                new_logo: this.emptyNewLogo(),
                logos: [],
                filter: '',
                showControls: false,
                saving: false,
                copyLogoImage: null
            };
        },
        mounted(){
            axios.get('/api/logos')
                .then((response)=>{
                    this.logos = response.data.logos;
                    this.showControls = response.data.admin;
                }).catch((error)=>{console.log(error);});
        },
        computed: {

        },
        methods: {
            copy(image, event){
                let ref =this.$refs.logoCopy;
                let button = event.target;
                ref.value = image;
                this.$refs.logoCopy.select();
                document.execCommand("Copy");
                this.copyLogoImage = image;
                button.focus();
            },
            emptyNewLogo(){
                return {
                    name: '',
                    url: '',
                    imagePreview: null,
                    file: null
                };
            },
            previewFileUpload(){
                let input = this.$refs.filepicker;
                if(input.files[0]){
                    this.new_logo.file = input.files[0];
                    this.new_logo.url = null;
                    this.new_logo.imagePreview = null;
                    let reader = new FileReader();

                    reader.onload = (e)=>{
                        let image = new Image();
                        image.onload = ()=>{
                            this.new_logo.imagePreview = image.src;
                            this.$forceUpdate();
                        };
                        image.src = e.target.result;
                    };
                    reader.readAsDataURL(this.new_logo.file);
                }
            },
            fetchExternal(){
                let image = new Image();
                image.onload = ()=>{
                    this.new_logo.imagePreview = image.src;
                    this.new_logo.file = null;
                    this.$refs.filepicker.value = '';
                    this.$forceUpdate();
                };
                image.src = this.new_logo.url;
            },
            saveNewLogo(){
                if(this.new_logo.name && (this.new_logo.file ||
                        (this.new_logo.url && [null, this.new_logo.url].includes(this.new_logo.imagePreview)))){
                    this.saving = true;
                    let data = new FormData();
                    this.fieldErrors = {};
                    data.append('name',this.new_logo.name);
                    let options = {};
                    if(this.new_logo.file) {
                        options = {headers: {'Content-Type': 'multipart/form-data'}};
                        data.append('image', this.new_logo.file);
                    } else {
                        data.append('url', this.new_logo.url)
                    }
                    axios.post('/admin/api/logos', data, options)
                        .then((response)=>{
                            if(response.data.status === 'ok'){
                                this.logos.unshift(response.data.logo);
                                this.new_logo = this.emptyNewLogo();
                            } else {
                                console.log(response.data);
                            }
                        }).catch((error)=>{
                        if(error.response){
                            console.log(error.response.statusText);
                        }
                    }).then(()=>{this.saving = false;});
                }
            }
        }
    }
</script>
<style lang="scss" scoped>

    .niceButton {

    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/logos-app.vue